import { Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { makeSelectIsAuthenticated } from 'reducers/auth/selectors';
import { makeSelectUserActive, makeSelectUserType } from 'reducers/user/selectors';
import { UserType } from 'enums/user-type';
import { NO_AUTH_LOCATION_PATHNAME } from 'constants';

const FAILED_PAYMENT_PATH = `${window._env_.production ? '/ui' : ''}/business/payment-failed`;
const LOGIN_PATH = `${window._env_.production ? '/ui' : ''}/login`;

enum EntityStatus {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

interface LoggedBusinessRouteProps{
  component: any;
  location: any;
  active: string;
  userType: string;
  isAuthenticated: boolean;
}

function LoggedBusinessRoute({ component: Component, location, active, userType, isAuthenticated, ...rest }: LoggedBusinessRouteProps) {

  if (!isAuthenticated) {
    const lastPosition = JSON.parse(localStorage.getItem(NO_AUTH_LOCATION_PATHNAME));
    const redirectUrl = lastPosition?.expiresAt >= new Date().getTime() && lastPosition?.pathName;
    if (!redirectUrl) {
      localStorage.setItem(
        NO_AUTH_LOCATION_PATHNAME,
        JSON.stringify({
          expiresAt: new Date().getTime() + 5 * 60000,
          pathName: `${location.pathname}${location.search}`,
        }),
      );
    }
  }

  const renderChidlren = (renderProps) => {

    if (!isAuthenticated) {
      return <Redirect to={{ pathname: LOGIN_PATH, state: { from: location } }} />
    }
    if (active === EntityStatus.INACTIVE && userType === UserType.business) {
      return <Redirect to={{ pathname: FAILED_PAYMENT_PATH, state: { from: location } }} />
    }

    return (<Fragment>
      <Component {...renderProps} />
    </Fragment>)
  }

  return <Route {...rest} render={renderChidlren} />;
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  userType: makeSelectUserType(),
  active: makeSelectUserActive(),
});

export default connect(mapStateToProps)(LoggedBusinessRoute);
